const fileSizeFormatter = new Intl.NumberFormat('ru-RU', {
  maximumFractionDigits: 1,
  minimumFractionDigits: 1,
});

export function formatFileSize(size: number): string {
  if (size < 1024) {
    return `${size} Б`;
  }

  if (size < 1024 * 1024) {
    return `${fileSizeFormatter.format(size / 1024)} КБ`;
  }

  return `${fileSizeFormatter.format(size / (1024 * 1024))} МБ`;
}
